import dynamic from 'next/dynamic';
import { ImageProps } from './Image.types';

export const Image = dynamic<ImageProps>(() => import('./Image').then(module => module.Image), { ssr: false });
